// eslint-disable-next-line import/prefer-default-export
export const UPDATE_TYPE_SYSTEM = 'UPDATE_TYPE_SYSTEM';
